import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'

export default function Spinner({ icon }) {
	icon = Spinner.simpleIcon(icon)
	return <span className="fa-layers fa-fw loading-spinner fa-4x mt-2 icon-muted">
		{icon && <FontAwesomeIcon {...icon} />}
		<FontAwesomeIcon icon="spinner" pulse transform="grow-20" />
	</span>
}

/**
 * Wrapper for string/object icon information.
 * @param icon {string|object} Either a string name of an icon, or FontAwesomeIcon props including `icon`
 * @returns {{icon: string}} Ready to be decomposed into a FontAwesomeIcon tag
 */
Spinner.simpleIcon = (icon) => typeof icon == 'string'? { icon } : icon

Spinner.propTypes = {
	icon: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.arrayOf(PropTypes.string),
		PropTypes.shape({
			icon: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
			flip: PropTypes.oneOf(['horizontal','vertical'])
		})
	])
}
